import { render } from "./phoneAlert.vue?vue&type=template&id=30d1b4f8&scoped=true"
import script from "./phoneAlert.vue?vue&type=script&lang=js"
export * from "./phoneAlert.vue?vue&type=script&lang=js"

import "./phoneAlert.vue?vue&type=style&index=0&id=30d1b4f8&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d1b4f8"]])

export default __exports__